import React from 'react';
import { useContext } from 'react';
import EmissionSpoolsState from '../../../context/emissionSpools/EmissionSpoolsState';
import themeContext from '../../../context/theme/themeContext';
import useEmissionSpools from '../../../hooks/web3/vault/useEmissionSpools';
import Cover from '../../../layout/Cover';
import AccumulatedVoSpool from '../Staking/Voting/AccumulatedVoSpool';
import EmissionSpoolChart from './EmissionSpoolChart';
import EmissionSpoolLeaderboard from './EmissionSpoolLeaderboard';
import EmissionSpools from './EmissionSpools';

const Gauge: React.FC = () => {
    const { theme } = useContext(themeContext);

    const { emissionSpools, isLoading } = useEmissionSpools();

    return (
        <div className={`vault-tab spool-emissions ${theme}`}>
            <Cover useMinHeight={true}>
                <div className='inner__left'>
                    <h2>Vote on SPOOL emissions</h2>
                </div>
                <div className='inner__right info'>
                    <AccumulatedVoSpool isEmission={true} />
                </div>
                <div />
                <div className='inner__right'>
                    <EmissionSpoolsState initialSortKey='tvr'>
                        <EmissionSpools />
                    </EmissionSpoolsState>
                </div>
                <div />
                {!isLoading &&
                    emissionSpools &&
                    !!emissionSpools.reduce(
                        (accAllocAmount, emissionSpool) =>
                            accAllocAmount + emissionSpool.allocAmount,
                        0
                    ) && (
                        <div className='inner__right statistics-container'>
                            <div className='statistics-title'>
                                <span>Current Results</span>
                                <div className='line' />
                            </div>
                            <div className='statistics-charts'>
                                <EmissionSpoolChart />
                                <EmissionSpoolLeaderboard />
                            </div>
                        </div>
                    )}
            </Cover>
        </div>
    );
};

export default Gauge;
